export default __webpack_public_path__ + "static/media/rocket_anim_99.ea9a42d0.png";